//********* SQFT *********//
import * as types from "./actionTypes";

export const setSQFTMenuOpened = (menuOpened = "") => ({
  type: types.SET_SQFT_MENU_OPENED,
  payload: {menuOpened}
});

export const setSQFTMenuOpenedLock = (menuOpenedLock = true) => ({
  type: types.SET_SQFT_MENU_LOCK,
  payload: {menuOpenedLock}
});

export const setSQFTActiveButton = (activeButton) => ({
  type: types.SET_SQFT_MENU_ACTIVE_BUTTON,
  payload: {activeButton}
});

export const setSQFTActiveSubMenuButton = (activeSubMenuButton) => ({
  type: types.SET_SQFT_ACTIVE_SUB_MENU_BUTTON,
  payload: {activeSubMenuButton}
});

export const setSQFTActiveLevel3Button = (activeLevel3Button = "") => ({
  type: types.SET_SQFT_ACTIVE_LEVEL3_BUTTON,
  payload: {activeLevel3Button}
});

export const setSQFTActiveRoomIndex = (activeRoomIndex) => ({
  type: types.SET_SQFT_ACTIVE_ROOM_INDEX,
  payload: {activeRoomIndex}
});

export const setSQFTActiveRoomType = (activeRoomType) => ({
  type: types.SET_SQFT_ACTIVE_ROOM_TYPE,
  payload: {activeRoomType}
});

export const setSQFTActiveRoomId = (activeRoomId) => ({
  type: types.SET_SQFT_ACTIVE_ROOM_ID,
  payload: {activeRoomId}
});

export const setSQFTActiveRoom = (activeRoom) => ({
  type: types.SET_SQFT_ACTIVE_ROOM,
  payload: {activeRoom}
});

export const setIsRoomSwitcherVisible = (isVisible) => ({
  type: types.SET_SQFT_ROOM_SWITCHER_VISIBLE,
  payload: {isVisible}
});

export const setFreeDrawMode = (isFreeDrawMode) => ({
  type: types.SET_FREE_DRAW_MODE,
  payload: {isFreeDrawMode}
});

export const setWallsUpMode = (isWallsUpMode) => ({
  type: types.SET_WALLS_UP_MODE,
  payload: {isWallsUpMode}
});

export const setWallsLockMode = (isWallsLockMode) => ({
  type: types.SET_WALLS_LOCK_MODE,
  payload: {isWallsLockMode}
});

export const setSQFTRoomLayouts = (roomLayouts) => ({
  type: types.SET_SQFT_ROOM_LAYOUTS,
  payload: {roomLayouts}
});

export const setSQFTContextMenu = (contextMenu) => ({
  type: types.SET_SQFT_CONTEXT_MENU,
  payload: {contextMenu}
});

export const setSQFTContextMenuV2 = (contextMenuV2) => ({
  type: types.SET_SQFT_CONTEXT_MENU_V2,
  payload: {contextMenuV2}
});

export const setSQFTSystemMessage = (systemMessage) => ({
  type: types.SET_SQFT_SYSTEM_MESSAGE,
  payload: {systemMessage}
});

export const setSQFTAr3dPopup = (ar3dPopup) => ({
  type: types.SET_SQFT_AR3D_POPUP,
  payload: {ar3dPopup}
});

export const setSQFTSystemDeleteMessage = (systemDeleteMessage) => ({
  type: types.SET_SQFT_SYSTEM_DELETE_MESSAGE,
  payload: {systemDeleteMessage}
});

export const setSQFTPopup = (sqftPopup) => ({
  type: types.SET_SQFT_POPUP,
  payload: {sqftPopup}
});

/**
  * Change Value Popups
 */
export const setChangeValuePopups = (changeValuePopups) => ({
  type: types.SET_CHANGE_VALUE_POPUPS,
  payload: {changeValuePopups}
});

export const addChangeValuePopup = (changeValuePopup) => ({
  type: types.ADD_CHANGE_VALUE_POPUP,
  payload: changeValuePopup
});

export const changeValuePopup = (changeValuePopup) => ({
  type: types.CHANGE_VALUE_POPUP,
  payload: changeValuePopup
});

export const deleteChangeValuePopup = (id) => ({
  type: types.DELETE_CHANGE_VALUE_POPUP,
  payload: {id}
});

/**
  * ValidationPopups
 */
export const setValidationPopups = (validationPopups) => ({
  type: types.SET_VALIDATION_POPUPS,
  payload: {validationPopups}
});

export const addValidationPopup = (validationPopup) => ({
  type: types.ADD_VALIDATION_POPUP,
  payload: validationPopup
});

export const validationPopup = (validationPopup) => ({
  type: types.VALIDATION_POPUP,
  payload: validationPopup
});

export const deleteValidationPopup = (id) => ({
  type: types.DELETE_VALIDATION_POPUP,
  payload: {id}
});

export const setShouldShowChangeShapeFeatureMissingMessage = (isShapeFeatureMissing) => ({
  type: types.SET_CHANGE_SHAPE_FEATURE_MISSING_MESSAGE,
  payload: {isShapeFeatureMissing}
});

export const setShapeIdsWithMissingFeature = (shapeIdsWithMissingFeature) => ({
  type: types.SET_SHAPE_IDS_WITH_MISSING_FEATURES,
  payload: {shapeIdsWithMissingFeature}
});

export const addShapeIdWithMissingFeature = (shapeIdsWithMissingFeature) => ({
  type: types.ADD_SHAPE_ID_WITH_MISSING_FEATURES,
  payload: shapeIdsWithMissingFeature
});

export const setSelectedCountertop = (selectedCountertop) => ({
  type: types.SET_SELECTED_COUNTERTOP,
  payload: {selectedCountertop}
})

export const setSelectedWall = (selectedWall) => ({
  type: types.SET_SELECTED_WALL,
  payload: {selectedWall}
});

export const setAbortController = (abortRequestController) => ({
  type: types.SET_ABORT_CONTROLLER,
  payload: {abortRequestController}
});

export const setIsItextEditing = (isITextEditing) => ({
  type: types.SET_IS_ITEXT_EDITING,
  payload: {isITextEditing}
});

export const setIsSlabPlaceholderOverlapsWithMultipleShapes = (isSlabPlaceholderOverlapsWithMultipleShapes) => ({
  type: types.SET_SLAB_PLACEHOLDER_OVERLAPS_WITH_MULTIPLE_SHAPES,
  payload: {isSlabPlaceholderOverlapsWithMultipleShapes}
});

export const setReCacheMenuCounter = (reCacheMenuCounter) => ({
  type: types.SET_RE_CACHE_MENU_COUNTER,
  payload: {reCacheMenuCounter}
});
